module.exports = __webpack_public_path__ + "static/img/241_TO8_2179_og.5ae8491.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/241_TO8_2179_og.jpg
// module id = P5qW
// module chunks = 0